import { render, staticRenderFns } from "./cpt-chart-gauge.vue?vue&type=template&id=23a587fd&scoped=true&"
import script from "./cpt-chart-gauge.vue?vue&type=script&lang=js&"
export * from "./cpt-chart-gauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a587fd",
  null
  
)

export default component.exports